import Input from "components/BaseWidgets/form/input";
import "./style.scss";
import Divider from "components/BaseWidgets/divider";
import Button from "components/BaseWidgets/button";
import { priceFormatPrice } from "utils/formatHelper";
import { useEffect, useState } from "react";
import { useCouponApply } from "hooks/api/usePlans";

function PriceDetailsCard({ plan, paymentDetails, createPayment }) {
  const baseurl = import.meta.env.VITE_REDIRECT;
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(0);

  useEffect(() => {
    setCouponCode("");
    setAppliedCoupon(null);
    setCouponDiscount(0);
  }, [plan]);

  const planPrice = plan.offerPrice ?? plan.oldPrice ?? 0;
  const totalPayable = Math.max(planPrice - couponDiscount, 0);

  const { mutate: applyCoupon } = useCouponApply({
    onSuccess: (data) => {
      const couponData = data?.data;
      setAppliedCoupon(couponData?.coupon_id);
      setCouponDiscount(couponData?.redeem_amount);
      createPayment({
        plan_id: plan?.plan_id,
        coupon_id: couponData?.coupon_id,
      });
    },
  });

  const handleApplyCoupon = () => {
    if (!couponCode) return;
    const coupon = couponCode.toUpperCase();
    applyCoupon({
      coupon_code: coupon,
      plan_id: plan?.plan_id,
    });
  };

  const handleRemoveCoupon = () => {
    setCouponCode("");
    setCouponDiscount(0);
    setAppliedCoupon(null);
    createPayment({
      plan_id: plan?.plan_id,
    });
  };

  const handlePayNow = () => {
    if (!paymentDetails?.url || !paymentDetails?.payload) {
      console.error("Payment details missing!");
      return;
    }

    const {
      key,
      txnid,
      amount,
      productinfo,
      firstname,
      email,
      phone,
      hash,
      surl,
      furl,
      lastname,
      address1,
      service_provider,
    } = paymentDetails.payload;

    let successUrl = `${baseurl}plans/list?txnid=${txnid}`;
    let failureUrl = `${baseurl}plans/list?txnid=${txnid}`;

    if (appliedCoupon) {
      successUrl += `&coupon_id=${appliedCoupon}`;
      failureUrl += `&coupon_id=${appliedCoupon}`;
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = paymentDetails.url;

    const orderedFields = {
      key,
      txnid,
      amount: parseFloat(amount).toFixed(2),
      productinfo,
      firstname,
      email,
      phone,
      lastname: lastname || "",
      address1: address1 || "",
      surl: paymentDetails.payload.surl || successUrl,
      furl: paymentDetails.payload.furl || failureUrl,
      hash,
      service_provider: service_provider || "payu_paisa",
      udf1: "",
      udf2: "",
      udf3: "",
      udf4: "",
      udf5: "",
    };

    Object.entries(orderedFields).forEach(([k, v]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = k;
      input.value = v ?? "";
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div className="price-details-card">
      <Input
        readOnly={!!appliedCoupon}
        className="coupon-input"
        placeholder="Enter coupon code"
        label="Redeem coupon"
        value={couponCode}
        onChange={(e) => setCouponCode(e.target.value)}
        addonAfter={
          <div className="flex gap-2 items-center">
            {!appliedCoupon ? (
              <Button
                size="sm"
                onClick={handleApplyCoupon}
                disabled={!couponCode.trim()}
              >
                Apply
              </Button>
            ) : (
              <Button size="sm" variant="link" onClick={handleRemoveCoupon}>
                Remove
              </Button>
            )}
          </div>
        }
      />
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3 justify-between">
          <span className="font-body-normal leading-1">Plan price:</span>
          <span className="font-title-xs fw-700 leading-4">
            {priceFormatPrice(planPrice, 1)}
          </span>
        </div>
        {appliedCoupon && (
          <div className="flex items-center gap-3 justify-between">
            <span className="font-body-normal leading-1">Coupon redeem</span>
            <span className="font-title-xs fw-700 leading-4 coupon-value">
              - {priceFormatPrice(couponDiscount, 1)}
            </span>
          </div>
        )}
        <Divider color="#D9D7D9" />
        <div className="flex items-center gap-3 justify-between">
          <span className="font-body-xl fw-700">Total payable</span>
          <span className="font-body-xl fw-700">
            {priceFormatPrice(totalPayable, 1)}
          </span>
        </div>
      </div>
      <Button
        isDisabled={!paymentDetails}
        onClick={handlePayNow}
        className="pay-now-btn"
        wFull
      >
        Pay now
      </Button>
    </div>
  );
}

export default PriceDetailsCard;
